import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as cls from 'classnames';
import { Route, Link, withRouter } from 'react-router-dom';
import Moment from 'react-moment';
import * as Config from '../../../configuration/consts';


@withRouter
export class ListItem extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.onEditForum = this.onEditForum.bind(this);
        this.onOpenForum = this.onOpenForum.bind(this);
    }

    onEditForum(event){
        this.props.editForum(this.props.item.id);
        event.preventDefault();
    }

    onOpenForum(event){
        this.props.getForumRequest(this.props.item.id, false)
    }

    render() {
        const { userRole, children, item, ...props } = this.props;
        const {id, title, lastActivityDate} = item;
        let isAdmin = userRole == Config.ROLE_GLOBAL_ADMIN;
        
        let editMode = isAdmin ? <span className="text-right"><button className="mx-2 btn btn-white" onClick={this.onEditForum}>
            <span className="fa fa-edit fa-lg"></span>
        </button> </span>: undefined;
        
        return (
       
            <div className="row pt-2 pb-2 clickable" onClick={this.onOpenForum} >
                <div className="col col-11">
                    <strong>{title.replace("<br/>", " ")}  {item.notificationCount ? 
                    <small>
                    <span className="fa-stack " style={{marginTop: "-5px"}}>
                        <i className="fa fa-circle fa-stack-2x text-red"></i>
                        <strong className="fa-stack-1x text-white">{item.notificationCount}</strong>
                    </span> </small>
                        : undefined }</strong>
                    
                    <span className="text-muted small"><Moment fromNow>{lastActivityDate}</Moment></span>
                    
                </div>
                <div className="col col-1">
                    {editMode}
                </div>
            </div>
        );
    }
}

/* <Link to={{ pathname: "/DiscussionBoard", search: `id=${id}` }}>

        </Link>
*/


// WEBPACK FOOTER //
// ./src/components/DiscussionBoard/Forum/ListItem.tsx